{
  "ic_resolver": {
    "local": "qvhpv-4qaaa-aaaaa-aaagq-cai",
    "staging": "extyd-kaaaa-aaaam-aafkq-cai",
    "ic": "fi3lu-jyaaa-aaaam-aafoa-cai"
  },
  "icp_resolver": {
    "local": "cwo4k-6aaaa-aaaam-aacba-cai",
    "staging": "cwo4k-6aaaa-aaaam-aacba-cai",
    "ic": "cwo4k-6aaaa-aaaam-aacba-cai"
  }
}